<template>
    <div class="coach-workload" :class="{ toggled: toggled }">
        <header class="page-header">
            <h1>{{ __('Workload') }}</h1>

            <button type="button" @click="toggle">
                <span v-if="toggled">{{ __('Collapse the workload') }}</span>
                <span v-else>{{ __('Expand workload') }}</span>
            </button>
        </header>

        <WorkloadCalendar date-switch />
    </div>
</template>

<script>
import WorkloadCalendar from './WorkloadCalendar.vue'

export default {
    components: {
        WorkloadCalendar
    },
    data() {
        return {
            toggled: false
        }
    },
    methods: {
        toggle() {
            this.toggled = !this.toggled
        }
    }
}
</script>
